import { render, staticRenderFns } from "./AppVersions.vue?vue&type=template&id=df0e4f8e&"
import script from "./AppVersions.vue?vue&type=script&lang=js&"
export * from "./AppVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports